module.exports = __webpack_public_path__ + "static/img/09.abc0752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/09.jpg
// module id = 6+t+
// module chunks = 1